import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { UnfoldMoreRounded, UnfoldLessRounded } from '@mui/icons-material';
import { ResponsiveIcon } from '../../icon/responsive';
import * as S from './styles';
export const WrapButton = memo(function WrapButton(props) {
    const { is_wrapped, word, onClick, ...rest } = props;
    return (_jsx(S.WrapButton, { startIcon: _jsx(ResponsiveIcon, { fontSize: "1.5em", Icon: is_wrapped ? UnfoldMoreRounded : UnfoldLessRounded }), onClick: onClick, ...rest, children: `${is_wrapped ? 'Развернуть' : ' Свернуть'} ${word}` }));
});
